import React from 'react';
import RestaurantDetail from '../components/RestaurantDetail';

const DetailPage = () => {
  return (
    <div>
      {/* 2nd page - Single Restaurant Detail */}
      <RestaurantDetail />
    </div>
  );
};

export default DetailPage;
